import React, { useState, useRef, useEffect } from "react";

import { useNavigate } from "react-router-dom";

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";

import TextField from "@mui/material/TextField";

import Grid from "@mui/material/Grid";

import styles from "./styles.module.css";

import { validarCodigoVerificacaoHandler } from "../../services/auth.service";

import MensagemSucesso from "../../components/MensagemSucesso";
import MensagemErro from "../../components/MensagemErro";


import SendIcon from "@mui/icons-material/Send";
import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import CircularProgress from "@mui/material/CircularProgress";

import { enviarCodigoVerificacaoHandler } from "../../services/auth.service";

import { styled } from "@mui/material/styles";
import ResponsivContent from "../../components/ResponsivContent";

export const ValidacaoCodigoEmail = () => {
  const navigate = useNavigate();

  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const [code, setCode] = useState(["", "", "", "", ""]);
  const inputRefs = useRef([]);
  const [codeRefDirection, setCodeRefDirection] = useState("");

  const SquareTextField = styled(TextField)({
    "& .MuiInputBase-input": {
      textAlign: "center",
    },
  });

  const handleVerificarCodigo = async (e) => {
    setLoading(true);
    const codeString = code.toString();
    const codigo = codeString.replace(/,/g, "");

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get("endereco").toString();

    await validarCodigoVerificacaoHandler({ email, codigo, app: "PT" })
      .then((response) => {
        setMsg(response.mensagem);
        handleOpenSnackbarSucesso();
        navigate("/dashboard");
      })
      .catch((err) => {
        if (err.response) {
          setMsg(err.response.mensagem);
          handleOpenSnackbarErro();
          setLoading(false);
        } else {
          setMsg("Por favor, tente novamente mais tarde.");
          handleOpenSnackbarErro();
          setLoading(false);
        }
      });
  };

  const [openSnackbarSucesso, setOpenSnackbarSucesso] = useState(false);
  const handleOpenSnackbarSucesso = () => {
    setOpenSnackbarSucesso(true);
  };

  const handleCloseSnackbarSucesso = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarSucesso(false);
  };

  const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
  const handleOpenSnackbarErro = () => {
    setOpenSnackbarErro(true);
  };

  const handleCloseSnackbarErro = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbarErro(false);
  };

  const handleChangeCode = (index, event) => {
    console.log(event);
    switch (event?.nativeEvent?.inputType) {
      case 'insertText': {
        const value = event.target.value.toUpperCase();
        if (value.length === 1) {
          const newCode = [...code];
          newCode[index] = value;
          setCode(newCode);
          setCodeRefDirection('forward');
        }
        break;
      }
      case 'insertFromPaste': {
        const value = event.nativeEvent.data.trim().toUpperCase().split('');
        if (value.length === 5) {
          const newCode = [...code];
          for (let i = 0; i < 5; i++) {
            newCode[i] = value[i];
          }
          setCode(newCode);
          setCodeRefDirection('forward');
        }
        break;
      }
      case 'deleteContentBackward': {
        const newCode = [...code];
        newCode[index] = '';
        setCode(newCode);
        setCodeRefDirection('backwards');
        break;
      }
      default:
        break;
    }
  };

  const handleKeyDownCode = (index, event) => {
    if (event.key === 'Backspace' && !event.target.value) {
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  }

  const handleEnviarEmailConfirmacao = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const email = urlParams.get("endereco").toString();
    await enviarCodigoVerificacaoHandler(email);
    setMsg("E-mail enviado com sucesso!");
    handleOpenSnackbarSucesso();
  };

  const handleLimpar = async () => {
    // Cria um novo array de códigos vazio
    const novoCodigo = Array(code.length).fill("");
    // Atualiza o estado do código com o novo array vazio
    setCode(novoCodigo);
  };

  useEffect(() => {
    if ( codeRefDirection ) {
      switch ( codeRefDirection ) {
        case 'forward': {
          console.log('forward');
          const nextIndex = code.findIndex((_, index) => !code[index]);
          if (nextIndex !== -1 && inputRefs.current[nextIndex]) {
            inputRefs.current[nextIndex].focus();
          }
          break;
        }
        case 'backwards': {
          console.log('backwards');
          const prevIndex = code.findIndex((_, index) => !code[index]) - 1;
          if (prevIndex !== -1 && inputRefs.current[prevIndex]) {
            inputRefs.current[prevIndex].focus();
          }
          break;
        }
        default:
          break;
      }
    }
  }, [code, inputRefs]);

  return (
    <div className={styles.pageContainer}>

      <ResponsivContent>
        <div className={styles.title}>
          <h2>Validação por e-mail</h2>
        </div>

        <section className={styles.containerSection}>
          <label className={styles.labelField}>
            Digite o código que foi enviado para o seu e-mail:
          </label>

          <div className={styles.textCodig}>
            {code.map((value, index) => (
              <SquareTextField
                key={index}
                inputRef={(el) => (inputRefs.current[index] = el)}
                value={value}
                onChange={(event) => handleChangeCode(index, event)}
                onKeyDown={(event) => handleKeyDownCode(index, event)}
                variant="outlined"
                size="small"
                type="text"
                maxLength={1}
                style={{
                  marginRight: index < code.length - 1 ? "12px" : 0,
                }}
              />
            ))}
          </div>

          <span className={styles.textoConfirmacao}>
            E-mail não confirmado. Digite o código de ativação enviado para o
            seu e-mail cadastrado.
          </span>

          <span className={styles.textoNovoCodigo}>
            <Button
              className={styles.botaoCliqueAqui}
              onClick={handleEnviarEmailConfirmacao}
            >
              Clique aqui
            </Button>
            para receber um novo código de ativação
          </span>

          <div className={styles.container__buttons}>
            <Button
              fullWidth
              onClick={handleLimpar}
              type="submit"
              className={styles.botao__limpar}
              variant="contained"
              startIcon={<PhonelinkEraseIcon />}
            >
              Limpar
            </Button>

            <Button
              fullWidth
              type="submit"
              className={styles.botao__enviar}
              variant="contained"
              onClick={handleVerificarCodigo}
              startIcon={<SendIcon />}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Enviar"
              )}
            </Button>
          </div>
        </section>
      </ResponsivContent>

      <MensagemSucesso
        open={openSnackbarSucesso}
        handleClose={handleCloseSnackbarSucesso}
        msg={msg}
      />

      <MensagemErro
        open={openSnackbarErro}
        handleClose={handleCloseSnackbarErro}
        msg={msg}
      />
    </div>
  );
};
